import { render, staticRenderFns } from "./UsersTable.vue?vue&type=template&id=b1fd6c12&"
import script from "./UsersTable.vue?vue&type=script&lang=ts&"
export * from "./UsersTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports